import React from 'react';
import ReactDOM from 'react-dom';

export default function Portal({children, parent, className}: any) {
  const el = React.useMemo(() => document.createElement('div'), []);
  React.useEffect(() => {
    const target = parent && parent.appendChild ? parent : document.body;
    const classList = ['portal-container'];
    if (className?.trim()) {
      className
        .trim()
        .split(' ')
        .forEach((cls: string) => {
          if (cls.trim()) {
            classList.push(cls);
          }
        });
    }
    classList.forEach((item) => el.classList.add(item));
    target.appendChild(el);
    return () => {
      target.removeChild(el);
    };
  }, [el, parent, className]);
  return ReactDOM.createPortal(children, el);
}
